import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from './useInView';

export default function About() {
  const [ref, inView] = useInView({ threshold: 0.2 });

  return (
    <section id="about" ref={ref} className="section-padding bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Image side */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-gradient-to-br from-gold-50 to-gold-100">
              <img
                src="/clinic-interior.webp"
                alt="Maison Beauté Clinic"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Accent block */}
            <div className="absolute -bottom-4 -right-4 w-full h-full rounded-2xl border-2 border-gold-200 -z-10" />
          </motion.div>

          {/* Text side */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="flex items-center gap-4 mb-6">
              <span className="gold-line" />
              <span className="text-xs tracking-[0.3em] uppercase text-gold-600 font-medium">
                About Dr. Noora
              </span>
            </div>

            <h2 className="heading-lg mb-6">
              Where Science Meets{' '}
              <span className="italic text-gold-500">Artistry</span>
            </h2>

            <div className="space-y-5 body-lg">
              <p>
                Dr. Noora Ibrahim is a board-certified aesthetic medicine
                specialist with over a decade of experience in advanced cosmetic
                procedures. Her philosophy centers on enhancing your natural
                beauty — never masking it.
              </p>
              <p>
                With training from leading institutions worldwide, Dr. Noora
                brings a refined artistic eye to every procedure. She believes
                that the best results are those that others can't quite pinpoint
                — you simply look refreshed, radiant, and like the best version
                of yourself.
              </p>
              <p>
                Every treatment plan is personally crafted by Dr. Noora, ensuring
                a bespoke approach tailored to your unique facial anatomy,
                skin type, and aesthetic goals.
              </p>
            </div>

            <div className="mt-10 flex flex-wrap gap-8">
              {[
                { title: 'MD, FAACS', desc: 'Board Certified' },
                { title: 'International', desc: 'Training & Expertise' },
                { title: 'Personalized', desc: 'Treatment Plans' },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-3">
                  <div className="w-1.5 h-1.5 rounded-full bg-gold-400 mt-2 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-charcoal-900 text-sm">
                      {item.title}
                    </p>
                    <p className="text-xs text-charcoal-400">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
